import * as y from "yup"
import {PBEnhancedContentCard, ContentCardBanner} from "../ContentCard"
import {ComponentBase, ContentCardID, baseSchema, idSchema} from "./base"

export interface Banner extends ComponentBase {
  title: string
  position: "top"
  subtitle?: string
  ctaCopy: string
  backgroundColor1?: string
  backgroundColor2?: string
  icon: string
  ctaUrlExternal?: boolean
  ctaUrl?: string // /wallet
  /**
   * Subsequent component to render when this banner is clicked
   */
  linkedComponent?: ContentCardID
}

export const BannerSchema = y.object<Banner>({
  ...baseSchema,
  title: y.string().required(),
  position: y.mixed().oneOf(["top"]).required(),
  ctaCopy: y.string().required(),
  subtitle: y.string(),
  backgroundColor1: y.string().required(),
  backgroundColor2: y.string(),
  icon: y.string(),
  ctaUrlExternal: y.boolean(),
  ctaUrl: y.string(),
  linkedComponent: idSchema
})

/**
 * Get a list of Banner components from a list of content Cards
 * TODO: some of these filters can be lifted up and shared
 */
export function filterBanners(cards: PBEnhancedContentCard[]): ContentCardBanner[] {
  return cards
    .filter((c): c is ContentCardBanner => c.extras.component_id === "banner" && !!c.extras.banner)
    .map((c) => {
      const {banner, popup} = c.extras

      // this is to remove external links if the popup has been defined
      if (banner?.linkedComponent === "popup" && popup && banner.ctaUrlExternal) {
        return {
          ...c,
          extras: {
            ...c.extras,
            banner: {
              ...banner,
              ctaUrlExternal: undefined,
              ctaUrl: undefined
            }
          }
        }
      } else {
        return c
      }
    })
}
